import { render } from "./tw-multiselect.vue?vue&type=template&id=1c04e33e&scoped=true"
import script from "./tw-multiselect.vue?vue&type=script&lang=js"
export * from "./tw-multiselect.vue?vue&type=script&lang=js"

import "./tw-multiselect.vue?vue&type=style&index=0&id=1c04e33e&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-1c04e33e"

export default script